var _typeof = require("/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/typeof");

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t(require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define(["react", "react-dom"], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.wds = t(require("react"), require("react-dom")) : e.wds = t(e.react, e["react-dom"]);
}("undefined" != typeof self ? self : this, function (e, t) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 12);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    e.exports = n(7)();
  }, function (e, t, n) {
    var r = n(6);

    e.exports = function (e, t) {
      if (null == e) return {};
      var n,
          o,
          i = r(e, t);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (o = 0; o < a.length; o++) {
          n = a[o], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
        }
      }

      return i;
    };
  },, function (e, n) {
    e.exports = t;
  },, function (e, t) {
    e.exports = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      }

      return o;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(8);

    function o() {}

    function i() {}

    i.resetWarningCache = o, e.exports = function () {
      function e(e, t, n, o, i, a) {
        if (a !== r) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: i,
        resetWarningCache: o
      };
      return n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "Slide", function () {
      return S;
    }), n.d(t, "Fade", function () {
      return _;
    }), n.d(t, "Zoom", function () {
      return k;
    });
    var r = n(2),
        o = n.n(r),
        i = n(0),
        a = n.n(i),
        s = n(1),
        u = n.n(s);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function p(e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      }

      return o;
    }

    function c(e, t) {
      e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
    }

    function d(e, t) {
      return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
    }

    var f = n(4),
        m = n.n(f),
        h = !1,
        x = a.a.createContext(null),
        E = function (e) {
      function t(t, n) {
        var r;
        r = e.call(this, t, n) || this;
        var o,
            i = n && !n.isMounting ? t.enter : t.appear;
        return r.appearStatus = null, t["in"] ? i ? (o = "exited", r.appearStatus = "entering") : o = "entered" : o = t.unmountOnExit || t.mountOnEnter ? "unmounted" : "exited", r.state = {
          status: o
        }, r.nextCallback = null, r;
      }

      c(t, e), t.getDerivedStateFromProps = function (e, t) {
        return e["in"] && "unmounted" === t.status ? {
          status: "exited"
        } : null;
      };
      var n = t.prototype;
      return n.componentDidMount = function () {
        this.updateStatus(!0, this.appearStatus);
      }, n.componentDidUpdate = function (e) {
        var t = null;

        if (e !== this.props) {
          var n = this.state.status;
          this.props["in"] ? "entering" !== n && "entered" !== n && (t = "entering") : "entering" !== n && "entered" !== n || (t = "exiting");
        }

        this.updateStatus(!1, t);
      }, n.componentWillUnmount = function () {
        this.cancelNextCallback();
      }, n.getTimeouts = function () {
        var e,
            t,
            n,
            r = this.props.timeout;
        return e = t = n = r, null != r && "number" != typeof r && (e = r.exit, t = r.enter, n = void 0 !== r.appear ? r.appear : t), {
          exit: e,
          enter: t,
          appear: n
        };
      }, n.updateStatus = function (e, t) {
        if (void 0 === e && (e = !1), null !== t) {
          this.cancelNextCallback();
          var n = m.a.findDOMNode(this);
          "entering" === t ? this.performEnter(n, e) : this.performExit(n);
        } else this.props.unmountOnExit && "exited" === this.state.status && this.setState({
          status: "unmounted"
        });
      }, n.performEnter = function (e, t) {
        var n = this,
            r = this.props.enter,
            o = this.context ? this.context.isMounting : t,
            i = this.getTimeouts(),
            a = o ? i.appear : i.enter;
        !t && !r || h ? this.safeSetState({
          status: "entered"
        }, function () {
          n.props.onEntered(e);
        }) : (this.props.onEnter(e, o), this.safeSetState({
          status: "entering"
        }, function () {
          n.props.onEntering(e, o), n.onTransitionEnd(e, a, function () {
            n.safeSetState({
              status: "entered"
            }, function () {
              n.props.onEntered(e, o);
            });
          });
        }));
      }, n.performExit = function (e) {
        var t = this,
            n = this.props.exit,
            r = this.getTimeouts();
        n && !h ? (this.props.onExit(e), this.safeSetState({
          status: "exiting"
        }, function () {
          t.props.onExiting(e), t.onTransitionEnd(e, r.exit, function () {
            t.safeSetState({
              status: "exited"
            }, function () {
              t.props.onExited(e);
            });
          });
        })) : this.safeSetState({
          status: "exited"
        }, function () {
          t.props.onExited(e);
        });
      }, n.cancelNextCallback = function () {
        null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null);
      }, n.safeSetState = function (e, t) {
        t = this.setNextCallback(t), this.setState(e, t);
      }, n.setNextCallback = function (e) {
        var t = this,
            n = !0;
        return this.nextCallback = function (r) {
          n && (n = !1, t.nextCallback = null, e(r));
        }, this.nextCallback.cancel = function () {
          n = !1;
        }, this.nextCallback;
      }, n.onTransitionEnd = function (e, t, n) {
        this.setNextCallback(n);
        var r = null == t && !this.props.addEndListener;
        e && !r ? (this.props.addEndListener && this.props.addEndListener(e, this.nextCallback), null != t && setTimeout(this.nextCallback, t)) : setTimeout(this.nextCallback, 0);
      }, n.render = function () {
        var e = this.state.status;
        if ("unmounted" === e) return null;
        var t = this.props,
            n = t.children,
            r = p(t, ["children"]);
        if (delete r["in"], delete r.mountOnEnter, delete r.unmountOnExit, delete r.appear, delete r.enter, delete r.exit, delete r.timeout, delete r.addEndListener, delete r.onEnter, delete r.onEntering, delete r.onEntered, delete r.onExit, delete r.onExiting, delete r.onExited, "function" == typeof n) return a.a.createElement(x.Provider, {
          value: null
        }, n(e, r));
        var o = a.a.Children.only(n);
        return a.a.createElement(x.Provider, {
          value: null
        }, a.a.cloneElement(o, r));
      }, t;
    }(a.a.Component);

    function v() {}

    E.contextType = x, E.propTypes = {}, E.defaultProps = {
      "in": !1,
      mountOnEnter: !1,
      unmountOnExit: !1,
      appear: !1,
      enter: !0,
      exit: !0,
      onEnter: v,
      onEntering: v,
      onEntered: v,
      onExit: v,
      onExiting: v,
      onExited: v
    }, E.UNMOUNTED = 0, E.EXITED = 1, E.ENTERING = 2, E.ENTERED = 3, E.EXITING = 4;

    var y = E,
        b = function b(e, t) {
      return e && t && t.split(" ").forEach(function (t) {
        return r = t, void ((n = e).classList ? n.classList.remove(r) : "string" == typeof n.className ? n.className = d(n.className, r) : n.setAttribute("class", d(n.className && n.className.baseVal || "", r)));
        var n, r;
      });
    },
        g = function (e) {
      function t() {
        for (var t, n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
          r[o] = arguments[o];
        }

        return (t = e.call.apply(e, [this].concat(r)) || this).appliedClasses = {
          appear: {},
          enter: {},
          exit: {}
        }, t.onEnter = function (e, n) {
          t.removeClasses(e, "exit"), t.addClass(e, n ? "appear" : "enter", "base"), t.props.onEnter && t.props.onEnter(e, n);
        }, t.onEntering = function (e, n) {
          var r = n ? "appear" : "enter";
          t.addClass(e, r, "active"), t.props.onEntering && t.props.onEntering(e, n);
        }, t.onEntered = function (e, n) {
          var r = n ? "appear" : "enter";
          t.removeClasses(e, r), t.addClass(e, r, "done"), t.props.onEntered && t.props.onEntered(e, n);
        }, t.onExit = function (e) {
          t.removeClasses(e, "appear"), t.removeClasses(e, "enter"), t.addClass(e, "exit", "base"), t.props.onExit && t.props.onExit(e);
        }, t.onExiting = function (e) {
          t.addClass(e, "exit", "active"), t.props.onExiting && t.props.onExiting(e);
        }, t.onExited = function (e) {
          t.removeClasses(e, "exit"), t.addClass(e, "exit", "done"), t.props.onExited && t.props.onExited(e);
        }, t.getClassNames = function (e) {
          var n = t.props.classNames,
              r = "string" == typeof n,
              o = r ? "" + (r && n ? n + "-" : "") + e : n[e];
          return {
            baseClassName: o,
            activeClassName: r ? o + "-active" : n[e + "Active"],
            doneClassName: r ? o + "-done" : n[e + "Done"]
          };
        }, t;
      }

      c(t, e);
      var n = t.prototype;
      return n.addClass = function (e, t, n) {
        var r = this.getClassNames(t)[n + "ClassName"];
        "appear" === t && "done" === n && (r += " " + this.getClassNames("enter").doneClassName), "active" === n && e && e.scrollTop, this.appliedClasses[t][n] = r, function (e, t) {
          e && t && t.split(" ").forEach(function (t) {
            return r = t, void ((n = e).classList ? n.classList.add(r) : function (e, t) {
              return e.classList ? !!t && e.classList.contains(t) : -1 !== (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ");
            }(n, r) || ("string" == typeof n.className ? n.className = n.className + " " + r : n.setAttribute("class", (n.className && n.className.baseVal || "") + " " + r)));
            var n, r;
          });
        }(e, r);
      }, n.removeClasses = function (e, t) {
        var n = this.appliedClasses[t],
            r = n.base,
            o = n.active,
            i = n.done;
        this.appliedClasses[t] = {}, r && b(e, r), o && b(e, o), i && b(e, i);
      }, n.render = function () {
        var e = this.props,
            t = (e.classNames, p(e, ["classNames"]));
        return a.a.createElement(y, l({}, t, {
          onEnter: this.onEnter,
          onEntered: this.onEntered,
          onEntering: this.onEntering,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }));
      }, t;
    }(a.a.Component);

    g.defaultProps = {
      classNames: ""
    }, g.propTypes = {};
    var C = g,
        O = ["slow", "normal", "fast"],
        N = (n(9), function (e) {
      var t = e.children,
          n = e.timeout,
          r = e.direction,
          i = e.speed,
          s = e.distance,
          u = o()(e, ["children", "timeout", "direction", "speed", "distance"]);
      return "fast" === i ? n = 150 : "slow" === i && (n = 350), a.a.createElement(C, Object.assign({
        classNames: "wds-slide--".concat(r, " wds-slide--speed-").concat(i, " wds-slide--distance-").concat(s, " wds-slide-"),
        timeout: {
          enter: n,
          exit: n
        },
        unmountOnExit: !0
      }, u), t);
    });
    N.displayName = "Slide", N.propTypes = {
      children: u.a.node.isRequired,
      direction: u.a.oneOf(["up", "right", "down", "left"]),
      timeout: u.a.number,
      speed: u.a.oneOf(O),
      distance: u.a.oneOf(["normal", "near", "far"])
    }, N.defaultProps = {
      direction: "up",
      speed: "normal",
      distance: "normal",
      timeout: 200
    }, N.__docgenInfo = {
      description: "",
      methods: [],
      displayName: "Slide",
      props: {
        direction: {
          defaultValue: {
            value: "'up'",
            computed: !1
          },
          type: {
            name: "enum",
            computed: !0,
            value: "motionDirections"
          },
          required: !1,
          description: ""
        },
        speed: {
          defaultValue: {
            value: "'normal'",
            computed: !1
          },
          type: {
            name: "enum",
            computed: !0,
            value: "motionSpeeds"
          },
          required: !1,
          description: ""
        },
        distance: {
          defaultValue: {
            value: "'normal'",
            computed: !1
          },
          type: {
            name: "enum",
            computed: !0,
            value: "motionDistances"
          },
          required: !1,
          description: ""
        },
        timeout: {
          defaultValue: {
            value: "200",
            computed: !1
          },
          type: {
            name: "number"
          },
          required: !1,
          description: ""
        },
        children: {
          type: {
            name: "node"
          },
          required: !0,
          description: ""
        }
      }
    };
    var S = N,
        T = (n(10), function (e) {
      var t = e.children,
          n = e.timeout,
          r = e.speed,
          i = o()(e, ["children", "timeout", "speed"]);
      return "fast" === r ? n = 150 : "slow" === r && (n = 350), a.a.createElement(C, Object.assign({
        classNames: "wds-fade--".concat(r, " wds-fade-"),
        timeout: {
          enter: n,
          exit: n
        },
        unmountOnExit: !0
      }, i), t);
    });
    T.displayName = "Fade", T.propTypes = {
      children: u.a.node.isRequired,
      timeout: u.a.number,
      speed: u.a.oneOf(O)
    }, T.defaultProps = {
      timeout: 250,
      speed: "normal"
    }, T.__docgenInfo = {
      description: "",
      methods: [],
      displayName: "Fade",
      props: {
        timeout: {
          defaultValue: {
            value: "250",
            computed: !1
          },
          type: {
            name: "number"
          },
          required: !1,
          description: ""
        },
        speed: {
          defaultValue: {
            value: "'normal'",
            computed: !1
          },
          type: {
            name: "enum",
            computed: !0,
            value: "motionSpeeds"
          },
          required: !1,
          description: ""
        },
        children: {
          type: {
            name: "node"
          },
          required: !0,
          description: ""
        }
      }
    };
    var _ = T,
        j = (n(11), function (e) {
      var t = e.children,
          n = e.timeout,
          r = o()(e, ["children", "timeout"]);
      return a.a.createElement(C, Object.assign({
        classNames: "wds-zoom-",
        timeout: {
          enter: n,
          exit: n
        },
        unmountOnExit: !0
      }, r), t);
    });
    j.displayName = "Zoom", j.propTypes = {
      children: u.a.node.isRequired,
      timeout: u.a.number
    }, j.defaultProps = {
      timeout: 250
    }, j.__docgenInfo = {
      description: "",
      methods: [],
      displayName: "Zoom",
      props: {
        timeout: {
          defaultValue: {
            value: "250",
            computed: !1
          },
          type: {
            name: "number"
          },
          required: !1,
          description: ""
        },
        children: {
          type: {
            name: "node"
          },
          required: !0,
          description: ""
        }
      }
    };
    var k = j;
  }]);
});